import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Stack, Paper } from "@mui/material";
import { TextField, Typography, TableRow, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableBody, Table } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useDispatch, useSelector } from "react-redux";
import { getEmployees } from "../company profile/employeesSlice";
import { saveIncentive } from "./httpCalls";
import Repo from "../../Repository/Repo";
import Loader from "../components/Loader";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { Toast } from "../components/Toast";
import { v4 as uuidv4 } from "uuid";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import EditIncentives from "./EditIncentives";

function Incentives({ item }) {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employee);
  const [records, setRecords] = useState([]);
  const [state, setState] = useState({
    loading: false,
    employee: "",
    incentivePer: "",
    saleTarget: "",
    deleteModal: false,
    selected: "",
    updateModal: false,
  });
  useEffect(() => {
    if (employees.length == 0) {
      dispatch(getEmployees());
    }
    getIncentives();
  }, []);

  const getIncentives = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.incentive({
      request: {
        method: "getIncentivesByItem",
        data: {
          company_code: localStorage.getItem("companyCode"),
          itemId: item._id,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      setRecords(data.response.data.incentivesArr);
    }
    setState((prev) => ({ ...prev, loading: false }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleEmployee = (e, val) => {
    setState((prev) => ({ ...prev, employee: val }));
  };
  const isOptionEqualToValue = (option, value) => {
    return option === value || value === "";
  };
  const handleSubmit = async () => {
    if (!state.employee) {
      Toast("info", "Select Employee");
      return;
    }
    if (!state.saleTarget) {
      Toast("info", "Add Sale Target");
      return;
    }
    if (!state.incentivePer) {
      Toast("info", "Add Incentive Percentage");
      return;
    }
    let id = uuidv4();
    let _id = id.replaceAll("-", "");
    let data = {
      _id,
      employeeId: state.employee.userId,
      employeeName: state.employee.userName,
      saleTarget: state.saleTarget,
      itemId: item._id,
      itemName: item.name,
      incentivePer: state.incentivePer,
    };
    let res = await saveIncentive(data);
    if (res.response.status.statusCode == 200) {
      Toast("success", "Incentive Added Successfully");
      setRecords((prev) => [{ ...data }, ...prev]);
    } else if (
      res.response.status.statusDescription ==
      "Incentive save failed! No Salary added"
    ) {
      Toast("info", "Kindly Add Employee Salary");
    } else {
      Toast("error", "Incentive Not Added");
    }

    setState((prev) => ({
      ...prev,
      employee: null,
      saleTarget: "",
      incentivePer: "",
    }));
  };
  const toggle = (item = "", name) => {
    setState((prev) => ({
      ...prev,
      selected: item,
      [name]: !prev[name],
    }));
  };
  const deleteRecord = async () => {
    try {
      toggle("", "deleteModal");
      let copy = JSON.parse(JSON.stringify(records));
      let foundIndex = copy.findIndex((i) => (i._id = state.selected._id));
      if (foundIndex) {
        copy.splice(foundIndex, 1);
        setRecords(copy);
      }
      let { data } = await Repo.incentive({
        request: {
          method: "deleteIncentive",
          data: {
            _id: state.selected._id,
            company_code: localStorage.getItem("companyCode"),
            employeeId: state.selected.employeeId,
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deleted Successfully");
      } else {
        Toast("error", "Incentive Not Deleted");
        getIncentives();
      }
    } catch (err) {
      console.log(err);
      Toast("error", "Error");
    }
  };
  return (
    <Stack spacing={2}>
      <Stack
        margin="10px 0px 5px 0px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box
          sx={{
            borderBottom: "1px solid black",
            width: "100%",
          }}
        />

        <Typography
          sx={{
            textAlign: "center",
            width: "100%",
            margin: "0 10px",
          }}
        >
          Incentives Section
        </Typography>
        <Box
          sx={{
            width: "100%",
            borderBottom: "1px solid black",
          }}
        />
      </Stack>
      <Autocomplete
        options={employees}
        getOptionLabel={(option) => option.userName || ""}
        isOptionEqualToValue={isOptionEqualToValue}
        onChange={(e, val) => {
          handleEmployee(e, val);
        }}
        renderInput={(params) => (
          <TextField {...params} size="small" label="Select Employee" />
        )}
      />

      <Stack direction="row" spacing={2} marginBottom="20px">
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          label="Sale Target"
          name="saleTarget"
          value={state.saleTarget}
          onChange={handleInput}
        />
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          label="Incentive %"
          name="incentivePer"
          value={state.incentivePer}
          onChange={handleInput}
        />
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="small" variant="contained" onClick={handleSubmit}>
          <AddCircleOutlineIcon sx={{ mr: 1 }} /> Add
        </Button>
      </Box>
      <Box sx={{ mt: 5 }}>
        {!state.loading && (
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 300 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Employee</TableCell>
                  <TableCell>Incentive %</TableCell>
                  <TableCell>Sale Target</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {records.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      {row.employeeName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.incentivePer}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ width: "150px" }}
                    >
                      {row.saleTarget}
                    </TableCell>
                    <TableCell
                      sx={{ width: "50px" }}
                      component="th"
                      scope="row"
                    >
                      <Stack direction="row" spacing={2}>
                        <BorderColorIcon
                          sx={{ cursor: "pointer", color: "#4eaf51" }}
                          onClick={() => toggle(row, "updateModal")}
                        />

                        <DeleteForeverIcon
                          sx={{ cursor: "pointer", color: "#DE2727" }}
                          onClick={() => toggle(row, "deleteModal")}
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {state.loading && <Loader loading={state.loading} />}
      </Box>
      <DeleteDialog
        title="Delete Item"
        open={state.deleteModal}
        onClose={() => toggle("", "deleteModal")}
        onClickYes={deleteRecord}
      />
      {state.updateModal && (
        <EditIncentives
          open={state.updateModal}
          onClose={() => toggle("", "updateModal")}
          item={state.selected}
          onSuccess={getIncentives}
        />
      )}
    </Stack>
  );
}

export default Incentives;
